<div class="ukprofile_container">
<mat-tab-group  class="demo-tab-group">
    <mat-tab label="User">
      <div class="demo-tab-content">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue.
        Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus.
        In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec,
        feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor,
        orci enim rutrum enim, vel tempor sapien arcu a tellus.
      </div>
    </mat-tab>
    
    <mat-tab label="Account">
      tab 2 
    </mat-tab>
    <mat-tab label="Permissions Admin">
        tab 3
      </mat-tab>
      
    
  </mat-tab-group>

</div>